module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_indonesia-7c1908ff.png";